<template>
  <div class="individual-price">
    <h4 class="price-title">{{ __('website.tariffs.individual_price') }}</h4>
    {{ __('website.tariffs.contact_us_for_calculation') }}
  </div>
</template>

<script>
export default {
  name: 'IndividualPrice',
};
</script>

<style lang="sass" scoped>
.individual-price
  margin: 0 0 16px
  text-align: center
  color: #fff
  line-height: 24px
  font-size: 16px
  color: #BCC4D2
  .price-title
    font-weight: 700
    font-size: 23px
    line-height: 48px
    margin: 0 0 4px
    color: #fff
</style>